import { Badge, Column } from '@synqo/frontend-component-library';
import {
    type ApiOrderPosition,
    type ApiOrderRelatedPosition,
    EnumProcessState,
    EnumTaxationMode,
    type EnumUnit,
    getBadgeVariantByProcessState,
    getEnumProcessStateLabel,
    getEnumUnitLabel,
    processStateOptions,
} from '@Model';
import { RelatedInvoicePosition } from '@Components/Billing/RelatedInvoicePosition';

export const orderPositionColumns = (taxationMode: EnumTaxationMode): Column<ApiOrderPosition>[] => [
    {
        name: 'number',
        label: 'Nr.',
        size: 75,
        disableColumnSort: false,
        disableColumnFilter: true,
    },
    {
        name: 'service.display_string',
        label: 'Leistung',
    },
    {
        name: 'process_state',
        label: 'Status',
        filterVariant: 'select',
        filterOptions: processStateOptions,
        renderCell: ({ cellData }) => (
            <Badge variant={getBadgeVariantByProcessState(cellData as EnumProcessState)}>
                {getEnumProcessStateLabel(cellData as EnumProcessState)}
            </Badge>
        ),
        size: 200,
    },
    {
        name: 'quantity',
        label: 'Menge',
        type: 'decimal',
        decimalPlaces: (rowData) => rowData.service.decimal_places_amount,
        size: 150,
    },
    {
        name: 'service.unit',
        label: 'MBez',
        renderCell: ({ cellData }) => getEnumUnitLabel(cellData as EnumUnit),
        size: 150,
    },
    {
        name: 'price_per_unit',
        label: 'Einzelpreis',
        type: 'currency',
        decimalPlaces: (rowData) => rowData.service.decimal_places_price,
        size: 200,
    },
    taxationMode === EnumTaxationMode.PriceIsGross
        ? {
              name: 'total_gross_price',
              label: 'Brutto Preis',
              type: 'currency',
              decimalPlaces: (rowData) => rowData.service.decimal_places_price,
              size: 150,
          }
        : {
              name: 'total_net_price',
              label: 'Netto Preis',
              type: 'currency',
              decimalPlaces: (rowData) => rowData.service.decimal_places_price,
              size: 150,
          },
    {
        name: 'related_positions',
        label: 'Rechnung',
        renderCell: ({ cellData }) => {
            const relatedPositions = cellData as ApiOrderRelatedPosition[];
            const relatedPosition = relatedPositions.find((r) => r.related_resource_name === 'invoices');
            if (relatedPosition === undefined) {
                return '';
            }
            return <RelatedInvoicePosition position={relatedPosition} />;
        },
        disableColumnFilter: true,
        disableColumnSort: true,
    },
];
